/**
 * The scopes the consent screen lists — exactly what will be granted.
 *
 * Granted = what the client asked for ∩ what the app is registered for (the
 * server downscopes the same way). Claude Desktop/Code ask for EVERY scope the
 * server advertises, so listing the raw request showed sensitive scopes the app
 * can never get (2026-10-20). With no explicit request the app's registration
 * is the default; while the app info is still loading the raw request is shown.
 */
export function scopesToDisplay(scopeParam: string, appScopes: string[] | null | undefined): string[] {
  const explicit = [...new Set(scopeParam.trim().split(/\s+/).filter(Boolean))];
  if (!explicit.length) return appScopes ?? [];
  return appScopes ? explicit.filter((s) => appScopes.includes(s)) : explicit;
}
